import { useMemo, useState } from 'react';
import { PageBreadcrumb, PageContentCard, PageTabs } from '../../../../../components/ui/ModulePage';
import { CourseTimeline } from '../components/CourseTimeline';
import { RoomSelector } from '../components/RoomSelector';
import { ScheduleHeader } from '../components/ScheduleHeader';
import { Toast } from '../components/Toast';
import { mockSchedule } from './mockData';
import { getCoursesForRoom, getScheduleStats } from './scheduleModel';

import '../styles/classroom-schedule.css';

interface ClassroomSchedulePageProps {
  now?: Date;
}

const demoTime = new Date(mockSchedule.systemTime);
const classroomScheduleTab = 'classroom-schedule';

export function ClassroomSchedulePage({ now = demoTime }: ClassroomSchedulePageProps) {
  const [selectedRoomId, setSelectedRoomId] = useState(mockSchedule.rooms[0]?.id ?? '');
  const [toast, setToast] = useState<string | null>(null);
  const selectedRoom = mockSchedule.rooms.find((room) => room.id === selectedRoomId);
  const courses = useMemo(() => getCoursesForRoom(mockSchedule.courses, selectedRoomId), [selectedRoomId]);
  const stats = useMemo(() => getScheduleStats(mockSchedule.courses, now), [now]);
  const schedulePanel = (
    <>
      <ScheduleHeader date={mockSchedule.date} now={now} stats={stats} onRefresh={() => setToast('已使用 mock 数据刷新课表')} />
      <div className="schedule-workbench">
        <RoomSelector
          rooms={mockSchedule.rooms}
          courses={mockSchedule.courses}
          now={now}
          selectedRoomId={selectedRoomId}
          onSelect={setSelectedRoomId}
        />
        <CourseTimeline
          room={selectedRoom}
          courses={courses}
          now={now}
          onAction={(course, action) => setToast(`已选择“${course.name}”的“${action.label}”操作`)}
        />
      </div>
    </>
  );

  return (
    <section className="classroom-schedule-kit-v3">
      <PageBreadcrumb current="教室课表" items={['教务管理', '课表和点名']} />
      <PageContentCard className="schedule-card">
        <PageTabs
          ariaLabel="课表和点名页面"
          onValueChange={(value) => {
            if (value === 'card-records') {
              setToast('刷卡记录页面暂未纳入本次设计交付');
            }
          }}
          panelClassName="schedule-tab-panel"
          tabs={[
            { id: classroomScheduleTab, label: '教室课表', panel: schedulePanel },
            { id: 'card-attendance', label: '刷卡考勤', disabled: true },
            { id: 'card-records', label: '刷卡记录' },
          ]}
          value={classroomScheduleTab}
        />
      </PageContentCard>
      <Toast message={toast} />
    </section>
  );
}
